// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'info-detail',
    templateUrl: './info-detail.component.html',
    styleUrls: ['./info-detail.component.scss'],
})
export class InfoDetailComponent implements OnInit {
    @Input() label: string;
    @Input() value: string;
    @Input() class: string;
    @Input() isDealsPage: boolean;

    constructor() {}

    ngOnInit() {}
}
